import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'

export interface DeletionPreview {
  isSoleMember: boolean
  isSolePlanner: boolean
  memberCount: number
  householdName: string | null
  willDeleteHousehold: boolean
  willPromoteMember: boolean
}

export function useDeletionPreview(enabled: boolean) {
  return useQuery({
    queryKey: ['account', 'deletion-preview'],
    queryFn: () => apiClient.get<DeletionPreview>('/api/v1/account/deletion-preview'),
    enabled,
  })
}
